import React from 'react';

const NoAccess = () => (
    <div className="content-page">
        <div className="container-fluid">
            <div className="container">
                <div className="row vh-50 justify-content-center align-items-center">
                    <div className="col-auto">
                        <div className="no-data-wrapper">
                            <div className="no-data-found">
                                <i className="ri-calendar-fill"></i>
                                <div className="bounce ripple">
                                    <i className="ri-checkbox-circle-fill"></i>
                                </div>
                                <p>No Access</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default NoAccess